import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import { sftpConnectionInitialValue } from 'components/organisms/forms/sftp-connection/SftpConnectionForm';
import { FormikHelpers } from 'formik';
import { useMutateOptions } from 'hooks';
import { useCustomParamId } from 'hooks/useParamId';
import { useTranslation } from 'react-i18next';
import { PiFloppyDisk, PiX } from 'react-icons/pi';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  useGetProviderSftpConnection,
  usePutProviderSftpConnection,
} from 'services/providers/sftp';
import { IProviderSftpConnectionResponse } from 'services/providers/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const EditSftpConnection = () => {
  const providerId = useCustomParamId('id', 'settings/provider');
  const salesChannelId = useCustomParamId(
    'salesChannelId',
    `settings/provider/${providerId}`
  );

  const { pathname } = useLocation();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const sftpConnection = useGetProviderSftpConnection(
    providerId,
    salesChannelId
  );

  const updateSftpConnection = usePutProviderSftpConnection();
  const mutateOptions = useMutateOptions<IProviderSftpConnectionResponse>();

  const onGoToDetail = () =>
    navigate(
      `/settings/provider/${providerId}/sftp-connection/${salesChannelId}/keys`
    );

  const submitForm = async (
    values: IProviderSftpConnectionResponse,
    helpers: FormikHelpers<IProviderSftpConnectionResponse>
  ) => {
    await updateSftpConnection.mutateAsync(
      {
        ...values,
        salesChannelId: salesChannelId,
        providerId: providerId,
      },
      {
        onSuccess: onGoToDetail,
        ...mutateOptions(helpers),
      }
    );
  };

  return (
    <Form.SftpConnection
      i18nextPrefix='label'
      initialValues={
        sftpConnection.data ? sftpConnection.data : sftpConnectionInitialValue
      }
      onSubmit={submitForm}
      customBackItem={
        <Button
          onlyIcon
          onClick={() => {
            navigate(
              `/settings/provider/${providerId}/sftp-connection/${salesChannelId}/keys`
            );
          }}>
          <Button.Description description={t('button.cancel')} />

          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <Button type='submit' variant={BUTTON_VARIANT.submit}>
          <Button.Text text={t('button.save')} />
          <Button.Icon icon={<PiFloppyDisk />} />
        </Button>
      }
      status={{ isLoading: sftpConnection.isLoading }}
    />
  );
};

export default EditSftpConnection;
